import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'widget-sparkline',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg [attr.viewBox]="'0 0 ' + genislik() + ' ' + yukseklik()" preserveAspectRatio="none" class="sparkline-svg">
      <defs>
        <linearGradient [attr.id]="gradientId" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" [attr.stop-color]="renk()" stop-opacity="0.3" />
          <stop offset="100%" [attr.stop-color]="renk()" stop-opacity="0.02" />
        </linearGradient>
      </defs>
      @if (noktalar().length > 1) {
        <polygon [attr.points]="alanNoktalari()" [attr.fill]="'url(#' + gradientId + ')'" />
        <polyline [attr.points]="cizgiNoktalari()" fill="none" [attr.stroke]="renk()" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round" />
      }
    </svg>
  `,
  styles: [`
    :host { display: block; line-height: 0; }
    .sparkline-svg { width: 100%; height: auto; }
  `],
})
export class SparklineComponent {
  veriler = input<number[]>([]);
  renk = input('#1890ff');
  genislik = input(120);
  yukseklik = input(40);

  readonly gradientId = 'sp-grad-' + Math.random().toString(36).slice(2, 8);

  noktalar = computed(() => {
    const v = this.veriler();
    if (!v?.length) return [];
    const g = this.genislik();
    const h = this.yukseklik();
    const pad = 2;
    const minV = Math.min(...v);
    const maxV = Math.max(...v);
    const range = maxV - minV || 1;
    const adim = v.length > 1 ? (g - pad * 2) / (v.length - 1) : 0;
    return v.map((d, i) => ({
      x: pad + i * adim,
      y: pad + (h - pad * 2) * (1 - (d - minV) / range),
    }));
  });

  cizgiNoktalari = computed(() =>
    this.noktalar().map(n => `${n.x},${n.y}`).join(' ')
  );

  alanNoktalari = computed(() => {
    const n = this.noktalar();
    if (n.length < 2) return '';
    const h = this.yukseklik();
    const cizgi = n.map(p => `${p.x},${p.y}`).join(' ');
    return `${n[0].x},${h} ${cizgi} ${n[n.length - 1].x},${h}`;
  });
}
